import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '') + '/hardware'

/** All circuit diagrams: { doc: { projects }, version, updated_at, updated_by, seeded }. */
export async function fetchHardware() {
  const r = await apiFetch(BASE)
  if (!r.ok) throw new Error(`hardware ${r.status}`)
  return r.json()
}

/**
 * Saves the diagrams as the next version. Resolves { ok, status, ...body }: 409 when someone
 * saved in between (body carries their version), 400 with `errors` when invalid.
 */
export async function saveHardware({ doc, baseVersion, summary }) {
  const r = await apiFetch(BASE, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ doc, baseVersion, summary }),
  })
  const body = await r.json().catch(() => ({}))
  return { ok: r.ok, status: r.status, ...body }
}

/** The last saves, newest first. */
export async function fetchHardwareVersions() {
  const r = await apiFetch(`${BASE}/versions`)
  if (!r.ok) throw new Error(`hardware versions ${r.status}`)
  return r.json()
}

/** One saved document (0 = the starting plans). */
export async function fetchHardwareVersion(version) {
  const r = await apiFetch(`${BASE}/versions/${encodeURIComponent(version)}`)
  if (!r.ok) throw new Error(`hardware version ${r.status}`)
  return r.json()
}

/** A repo's firmware source archive (zip bytes, files under "<repo>/"). */
export async function fetchFirmwareArchive(repo) {
  const r = await apiFetch(`${BASE}/firmware/${encodeURIComponent(repo)}`)
  if (!r.ok) throw new Error(r.status === 404 ? 'Keine Firmware hinterlegt' : `firmware ${r.status}`)
  return r.arrayBuffer()
}
